import styled from 'styled-components';
import Column from '@sdk/components/ui/spacing/Column';

export const Container = styled(Column)`
  flex-shrink: 1;
  box-sizing: border-box;
  width: 580px;
  max-width: 580px;
  min-height: 364px;
  padding: 20px 5px;
`;
